var LANG = {
	"clientConnectionError" : 'Vos identifiants de connexion sont incorrects',
	"optionsTri" : {
		"top" : 'Popularité',
		"moyavis" : 'Avis clients',
		"nomaz" : 'Nom A->Z',
		"nomza" : 'Nom Z->A',
		"prixasc" : 'Prix le + bas',
		"prixdesc" : 'Prix le + élevé',
		"rank" : 'Pertinence',
		"pctreduc" : '% de Réduction',
		"datedesc" : 'Nouveautés',
		"dateasc" : 'Le plus ancien',
		"qteasc" : 'Stock -',
		"qtedesc" : 'Stock +',
		"margeasc" : '% Marge -',
		"margedesc" : '% Marge +'
	},
	"client_existe" : 'Un compte avec ce mail existe déjà.',
	"client_existebis" : 'Un compte correspondant à cette adresse e-mail existe déjà.<br />Veuillez saisir votre mot de passe ou cliquez <a href="/clients/?pg=lost">ici</a> si vous l\'avez oublié.',
	"clientInvalidForm" : 'Formulaire incomplet',
	"form" : {
		"error" : {
			"required" : 'Ce champ est obligatoire',
			"array" : 'Ce champ doit être un tableau de valeurs',
			"civilite" : 'La civilité que vous avez sélectionné n\'est pas valide',
			"codepostal_5_chiffres" : 'Le code postal doit avoir 5 chiffres',
			"codepostal" : 'Code postal manquant ou non reconnu.',
			"egal" : 'Ce champ n\'a pas été confirmé correctement',
			"email" : 'Ce champ doit être au format E-mail',
			"emailDomain" : 'Votre e-mail ne semble pas valide',
			"file" : 'Le fichier soumis n\'est pas valide',
			"int" : 'Ce champ doit être un entier',
			"length_from_to" : 'Ce champ doit avoir entre {0} et {1} caractères',
			"length_from" : 'Ce champ doit avoir au minimum {0} caractères',
			"length_to" : 'Ce champ doit avoir au maximum {0} caractères',
			"password" : 'Le mot de passe doit contenir entre {0} et {1} caractères',
			"prenomnom" : 'Veuillez saisir à la suite votre prénom et votre nom de famille en les séparants par un espace',
			"pays" : 'Ce champ doit être renseigné',
			"telfixe" : 'Le n° fixe est vide ou invalide.',
			"telmobile" : 'Le n° portable est vide ou invalide.'
		}
	},
	"parentT" : {
		"p1" : 'Fille - Fils',
		"p2" : 'Petite-fille - Petit-fils',
		"p3" : 'Nièce - Neveu',
		"p4" : 'Soeur - Frère',
		"p5" : 'Filleul(e)',
		"p6" : 'Autre'
	},
	"filtres" : {
		"typeNouveaute" : 'Nouveauté',
		"typeRetourStock" : 'De retour en stock',
		"typePromotion" : 'Promotion',
		"typeBonneAffaire" : 'Bonne affaire',
		"typeDestockage" : 'Coup de cœur',
		"typeSolde" : 'Soldes',
		"typeObsolete" : 'Obsolète',
		"typeOffreDuMoment" : 'Offre du moment',
		"siteRef" : 'Thème',
		"rangePalier" : 'de {0} à {1}{2}',
		"rangeMax" : 'plus de {0}{1}',
		"prixPalier" : 'de {0} à {1}€',
		"prixMax" : 'plus de {0}€',
		"promoPalier" : 'de {0} à {1}%',
		"promoMax" : 'plus de {0}%'
	},
	"defaultFiltresAttribut" : {
		"atr0" : 'Tous les choix',
		"atr3" : 'Toutes les échelles',
		"atr152" : 'Toutes les tailles',
		"atr542" : 'Tous les sujets',
		"atr572" : 'Tous les artistes',
		"atr168" : 'Tous les formats',
		"atr573" : 'Toutes les formes',
		"atr543" : 'Tous les personnages'
	},
	"trancheAge" : {
		"palier" : 'de %1$s %2$s à %3$s %4$s',
		"max" : 'à partir de %1$s %2$s'
	},
	"civilite" : {
		"M" : 'M.',
		"Mme" : 'Mme',
		"Mlle" : 'Mlle'
	},
	"panier" : {
		"articles" : '{0}',
		"articles/zero" : '0',
		"articles_euros" : '{0}',
		"articles_euros/zero" : '0'
	},
	"panierAriane" : {
		"state1" : 'Panier',
		"state2" : 'Adresse et livraison',
		"state3" : 'Paiement'
	},
	"clientAriane" : {
		"coordonnees" : 'Vos coordonnées',
		"mescoordonnees" : 'Mes coordonnées',
		"adressemail" : 'Modification de l\'adresse mail',
		"motdepasse" : 'Modifier mon mot de passe',
		"sav" : 'Ecrire au service client',
		"commandes" : 'Consulter mes commandes',
		"porte_monnaie" : 'Mon porte-monnaie',
		"sauvegarde" : 'Mes sauvegardes de panier',
		"wishlist" : 'Mes listes de souhaits',
		"wishlist_new" : 'Je crée ma liste de souhaits',
		"wishlist_detail" : 'Ma liste',
		"wishlist_share" : 'Je partage ma liste',
		"suivi" : 'Suivre mes commandes',
		"myavis" : 'Mes avis',
		"setavis" : 'Donnez votre avis',
		"cfwelcome" : 'Mon Espace "Club Fidélité"',
		"cfinformations" : 'Mes informations',
		"cfprogramme" : 'Le programme "Club Fidélité"',
		"cfcheques" : 'Mes Chèques "Club Fidélité"',
		"newsletters" : 'Newsletter'
	},
	"alertQuantiteError" : 'Quantité invalide',
	"alertMaxQty" : 'Vous avez les [stock] dernier(s) exemplaire(s) dans votre panier.',
	"alertStockInPanier" : 'Il ne nous reste plus que {1} exemplaire(s) en stock. Vous avez {0} exemplaires de ce produit dans votre panier',
	"alertStockInPanier/one" : 'Il ne nous reste plus que {1} exemplaire(s) en stock. Vous avez 1 exemplaire de ce produit dans votre panier',
	"alertStockInPanier/zero" : 'Il ne nous reste plus que {1} exemplaire(s) en stock.',
	"jsMiseEnPanier" : 'Ajouté au panier',
	"livraison_indisponible" : 'Livraison indisponible<br />(commande volumineuse)',
	"etape2_relais_portable_title" : 'Votre n° de portable est nécessaire',
	"etape2_relais_portable_text" : 'Il permettra au transporteur de vous prévenir de l\'arrivée de votre colis.',
	"etape2_relais_no_result" : 'Malheureusement, aucun relais assez proche n\'est disponible. Vous pouvez néanmoins essayer un autre point relais.',
	"estimated_delivery_text_root" : 'Livraison prévue',
	"estimated_delivery_text_root_partial" : 'Livraison partielle prévue',
	"estimated_delivery_text_root_christmas" : 'Livraison garantie pour Noël prévue',
	"estimated_delivery_text" : 'Livraison entre le {0} et le {1}',
	"estimated_delivery_text_single" : 'Livraison prévue le {0}',
	"estimated_delivery_array" : 'le {0} et le {1}',
	"estimated_delivery_array_single" : 'le {0}',
	"product_estimated_delivery_text" : 'Livré entre le {0} et le {1}',
	"product_estimated_delivery_text_single" : 'Livré le {0}',
	"product_estimated_delivery_text_chrono" : 'ou choisissez la livraison Express pour être livré le {0}',
	"delivered_home" : 'Livré chez vous',
	"delivered" : 'Livré',
	"delivered_estimated" : 'Livré entre',
	"delivered_in_two_weeks" : 'Livraison sous 2 semaines',
	"type_delivery_text" : {
		"code55" : 'Retrait en consigne automatique',
		"code3" : 'Retrait sous 24H en point relais',
		"code61" : 'Livraison chez vous',
		"code60" : 'Livraison chez vous (avec signature)',
		"code2" : 'Livraison chez vous',
		"code8" : 'Retrait dans nos locaux à Boussay (44190) en Loire-Atlantique',
		"code12" : '',
		"code14" : '',
		"code5" : '',
		"code4" : '',
		"code34" : '',
		"code69" : '',
		"code68" : '',
		"code67" : '',
		"code66" : '',
		"code63" : '',
		"code62" : '',
		"code35" : '',
		"code50" : 'Livraison en point relais',
		"code20" : '',
		"codeautre" : 'Livraison à domicile'
	},
	"age" : {
		"month" : 'mois',
		"month/one" : 'mois',
		"year" : 'ans',
		"year/one" : 'an'
	},
	"product" : {
		"recommandedAge" : 'Recommandé dès {0} {1}',
		"recommandedAge/zero" : 'Recommandé dès la naissance',
		"recommandedAgeFeatureFromTo" : 'De {0} {1} à {2} {3}',
		"recommandedAgeFeatureFrom" : '+ de {0} ans',
		"recommandedAgeFeatureFrom/one" : '+ de {0} an',
		"ratings" : '{0} avis',
		"ratings/one" : '{0} avis',
		"share" : 'Partager'
	},
	"devise" : {
		"signe" : '€',
		"prix" : '{0}<sup>€{1}</sup>',
		"prixTexte" : '{0}&nbsp;EUR'
	},
	"ariane" : {
		"accueil" : 'Accueil',
		"blog" : 'Le blog Avenue des Jeux'
	},
	"productType" : 'Jouets',
	"codePromo" : {
		"code0" : 'C\'est noté, votre code à bien été pris en compte .',
		"code1" : 'Votre réduction a bien été prise en compte sur les produits éligibles.',
		"code2" : 'Désolé mais ce code est périmé ou inconnu.',
		"code3" : 'Pour profiter de votre offre, merci de vous identifier.',
		"code4" : 'Nous sommes désolés, mais votre sélection de produits ne correspond pas aux critères d\'application de ce code.',
		"code5" : 'Nous sommes désolés, mais ce code ne s\'applique pas aux produits déjà en promotion.',
		"code6" : '',
		"code7" : 'Nous sommes désolés, mais le produit offert concerné par votre code promo n\'est plus en stock.',
		"code9" : 'Votre code a bien été pris en compte, mais les produits offerts par votre code promo ne sont plus en stock. La promotion a néanmoins été appliquée à votre panier.',
		"code8" : 'Votre code a bien été pris en compte, mais certains des produits offerts concernés par votre code promo ne sont plus en stock. Les autres ont été ajoutés à votre panier.',
		"code10" : 'Nous sommes désolés, mais ce code nécessite d\'avoir passé un nombre de commandes spécifique.'
	},
	"caddieOption" : {

	},
	"panierOffreSpeciale" : 'CADEAU OFFERT : ',
	"panierFraisTraitement" : 'Frais de traitement',
	"panierCgv" : 'Vous devez lire et accepter les conditions générales de vente',
	"prixDevise" : '{0}&nbsp;€',
	"prixDeviseTxt" : '{0} EUR',
	"gratuit" : 'Gratuit',
	"formatDateStrtotime" : {
		"date" : 'd/m/Y',
		"interval" : '%d days'
	},
	"formatDate" : {
		"date" : '%x',
		"dateComplete" : '%e %B %Y',
		"jourMois" : '%e %B',
		"dateHeure" : '%d/%m/%Y %R',
		"dateTime" : '%d/%m/%Y %T',
		"dateMoisHeureMinute" : '%d/%m %R',
		"dateJourHeure" : '%A %d/%m/%Y %R',
		"dateJour" : '%A %d/%m/%Y'
	},
	"js_filtre_prix" : 'de $1 € à $2 €',
	"generique_age_126" : '0 à 3 mois',
	"generique_age_127" : '0 à 6 mois',
	"generique_age_137" : '0 à 1 an',
	"generique_age_144" : '0 à 2 ans',
	"generique_age_145" : '0 à 3 ans',
	"generique_age_146" : '0 à 4 ans',
	"generique_age_147" : '0 à 5 ans',
	"generique_age_148" : '0 à 6 ans',
	"generique_age_149" : '0 à 7 ans',
	"generique_age_154" : '0 à 8 ans',
	"generique_age_155" : '0 à 9 ans',
	"generique_age_156" : '0 à 10 ans',
	"generique_age_157" : '0 à 11 ans',
	"generique_age_158" : '0 à 12 ans',
	"generique_age_165" : '0 à 13 ans',
	"generique_age_166" : '0 à 14 ans',
	"generique_age_167" : '0 à 15 ans et plus',
	"prix_devise" : '{0}&nbsp;€',
	"prix_devise_txt" : '{0} EUR',
	"produit_trop_lourd" : '<font color="red">Envoi impossible car le produit "<b>%s</b>" pèse <b>%s kg</b> et dépasse le maximum autorisé de <b>%s kg</b>. Nous vous invitons à prendre contact avec notre Service client.</font>',
	"ht" : 'HT',
	"ttc" : 'TTC',
	"marque" : 'Marques',
	"licence" : 'Licences',
	"civilite_1" : 'Monsieur',
	"civilite_2" : 'Madame',
	"civilite_3" : 'Mademoiselle',
	"client_invalid_nd" : 'Votre numéro de dossier n\'est pas valide.',
	"client_connection_error" : 'Vos identifiants de connexion sont incorrects',
	"client_code_porte" : 'Code porte',
	"client_code_porte2" : 'Code immeuble',
	"client_interphone" : 'Interphone',
	"client_invalid_cp_5_chiffre" : 'Le code postal doit avoir 5 chiffres',
	"client_invalid_mail" : 'Assurez-vous de saisir une adresse mail valide.',
	"client_invalid_pwd" : 'Votre mot de passe doit être composé d\'au moins 6 caractères.',
	"client_invalid_pwd2" : 'Le mot de passe n\'est pas confirmé.',
	"client_invalid_telfixe" : 'Le n° fixe est vide ou invalide.',
	"client_invalid_nom" : 'Veuillez saisir à la suite vos prénom(s) et nom de famille en respectant un espace entre chaque mot.',
	"client_invalid_prenom" : 'Le prénom est vide ou invalide.',
	"client_invalid_adresse1" : 'Adresse non reconnue ou incomplète.',
	"client_invalid_cp" : 'Code postal manquant ou non reconnu .',
	"client_invalid_ville" : 'La ville est vide ou invalide.',
	"client_invalid_pays" : 'Le pays est vide ou invalide.',
	"client_modifie_pays" : 'Le pays a été modifié.',
	"client_invalid_telG" : 'N° de téléphone manquant ou incorrect.',
	"client_invalid_telport" : 'Le n° portable est vide ou invalide.',
	"client_invalid_fax" : 'Le n° fax est vide ou invalide.',
	"client_invalid_ddn" : 'Il semblerait que cette date de naissance soit non conforme ou improbable.',
	"client_invalid_password" : 'Le mot de passe est vide, invalide ou ne correspond pas.',
	"client_invalid_modeliv" : 'Le mode de livraison choisi n\'est pas disponible',
	"client_modification_mail_existe" : 'Un autre compte client avec ce mail existe déjà. Vous pouvez tenter de vous déconnecter puis de vous connecter avec cette adresse mail.',
	"client_erreur_insertion" : 'Un problème technique temporaire a provoqué une erreur lors de votre inscription, merci de réessayer dans quelques minutes.',
	"client_erreur_update_adresse" : 'Un problème technique temporaire a provoqué une erreur, merci de réessayer dans quelques minutes.',
	"client_modification_commande" : 'Modification de la commande',
	"client_modification_adresse" : 'Modifier une adresse',
	"client_ajout_adresse" : 'Ajouter une adresse de livraison',
	"client_adresse_facturation" : 'Adresse de facturation',
	"client_adresse_livraison" : 'Adresse de livraison',
	"client_adresse_livraison_principale" : 'Adresse de livraison principale',
	"client_modification_adresse_facturation" : 'Modifier votre adresse de facturation',
	"client_modification_adresse_livraison" : 'Modifier votre adresse de livraison',
	"client_confirm_suppression_adresse" : 'Supprimer cette adresse ?',
	"client_erreur_generique" : 'Notre serveur est actuellement indisponible, nous vous invitons à vous reconnecter ultérieurement à votre espace client pour retrouver votre commande.',
	"client_note_error" : 'Vous devez sélectionner une note.',
	"client_avis_error" : 'Vous devez rédiger un commentaire.',
	"client_pseudoregex_error" : 'Le pseudo doit contenir au moins 5 caractères, que des lettres et des chiffres.',
	"client_pseudodeja_error" : 'Ce pseudo n\'est pas disponible.',
	"client_pseudo_error" : 'Le pseudo est vide ou invalide.',
	"client_corse_chronopost" : 'La livraison en Chronopost n\'est pas disponible pour cette destination',
	"client_sav_message_error" : 'Votre message est vide ou invalide.',
	"client_sav_upload_error" : 'Erreur lors du téléchargement des fichiers. Veuillez vérifier si la taille et le format des fichiers sont pris en charge.',
	"client_sav_commande_error" : 'Veuillez sélectionner une commande.',
	"client_sav_categorie_invalid" : 'Veuillez sélectionner une catégorie.',
	"client_livraison_gratuite" : 'Gratuit avec votre code promo',
	"client_invalid_pack" : 'Ce pack n\'est pas disponible',
	"client_invalid_form" : 'Formulaire incomplet',
	"client_password" : 'Mot de passe',
	"client_invalid_formulaire" : 'Formulaire incomplet ou données invalides. Merci de corriger ou compléter les informations requises dans les espaces apparaissant en rouge et signalés par des messages d\'alerte',
	"avisUtile" : '{0} personnes ont trouvé cela utile',
	"avisUtile/one" : '1 personne a trouvé cela utile',
	"avisUtile/zero" : '',
	"wish_in" : 'Ce produit est dans votre liste préférée',
	"wish_open" : 'Consulter ma liste préférée',
	"wish_del" : 'Supprimer ce produit de ma liste préférée',
	"wish_add" : 'Ajouter à ma liste préférée',
	"comgroup_total_maxi" : 'Votre commande dépasse le montant maximal autorisé pour votre compte qui est de ',
	"comgroup_interdit" : 'Les articles suivants ne font pas partie de votre offre :',
	"comgroup_interdit2" : 'Vous devez les enlever de votre panier pour passer commande.',
	"comgroup_date" : 'Votre compte n\'est pas actif actuellement : vous ne pouvez pas passer commande.',
	"comgroup_produit" : 'Ce produit ne fait pas partie de votre offre',
	"code_promo_negatif" : 'Désolé, mais ces produits ne peuvent bénéficier de cette offre promotionnelle.',
	"pack_1" : 'Garantie classique',
	"pack_2" : 'Garantie suivi SMS',
	"pack_4" : 'Garantie tranquillité + suivi SMS',
	"pack_5" : 'Garantie tranquillité ',
	"pack_3" : 'Garantie privilège',
	"js_instructions" : 'Instructions de livraison',
	"js_portable_destinataire" : 'Téléphone portable du destinataire',
	"pack_1_desc" : 'Descriptif du Pack gratuit',
	"pack_2_desc" : 'Descriptif du Pack suivi SMS',
	"pack_4_desc" : 'Descriptif du Pack sérénité + suivi SMS',
	"pack_3_desc" : 'Descriptif du Pack tranquillité ',
	"pack_5_desc" : 'Descriptif du Pack sérénité',
	"sms_envoi_vers" : 'Les SMS seront envoyés au ',
	"expediee" : 'Commande expédiée',
	"enPreparation" : 'Commande en cours de préparation',
	"enAttente" : 'Commande en attente de préparation',
	"enTraitement" : 'En cours de traitement',
	"nonPayee" : 'En attente de votre règlement',
	"avoirDispo" : 'Télécharger l\'avoir PDF généré le {0}',
	"factureDispo" : 'Télécharger la facture PDF',
	"devisDispo" : 'Télécharger le devis PDF',
	"marketplace" : 'Commande marketplace',
	"alert_problemStock" : 'Plusieurs produits de votre panier ne sont plus disponibles dans la quantité demandée. Vous devez les modifier pour pouvoir continuer.',
	"alert_problemStock/one" : 'Le produit signalé ci-dessous n\'est plus disponible dans la quantité demandée. Vous devez le modifier pour pouvoir continuer.',
	"alert_quantite_error" : 'Quantité invalide',
	"alert_problemStockButton" : 'Mettre à jour le panier',
	"alert_problemStockButtonFromEtape3" : 'Mettre à jour et revenir au panier',
	"alert_maxqte" : 'Vous avez les {0} derniers exemplaires dans votre panier.',
	"alert_maxqte/one" : 'Vous avez le dernier exemplaire dans votre panier.',
	"js_stock_vide" : 'Il ne nous reste plus que [stock] exemplaire(s) en stock.',
	"alert_stock_in_panier" : 'Il ne nous reste plus que {0} exemplaire(s) en stock. Vous avez {1} exemplaire(s) de ce produit dans votre panier',
	"js_miseenpanier" : 'Ajouté',
	"alert_errorSaveAsCommande" : 'Il y a eu un problème lors de l\'enregistrement de votre panier. Notre équipe en a été informée immédiatement, nous vous invitons à réessayer ultérieurement.',
	"nb_stock_full" : 'En stock',
	"nb_stock_low" : 'Plus que {0} articles en stock',
	"nb_stock_low/one" : 'Plus que 1 article en stock',
	"nb_stock_low/zero" : 'Article indisponible',
	"exemplaires_en_stock" : '{0} exemplaires en stock',
	"exemplaires_en_stock/one" : '1 exemplaire en stock',
	"exemplaires_en_stock2" : '{0} produits',
	"exemplaires_en_stock2/one" : '1 produit',
	"moins_de_exemplaires_en_stock" : 'Moins de %s exemplaires en stock',
	"plus_de_exemplaires_en_stock" : 'Plus de %s exemplaires en stock',
	"pagination_produits" : 'produits',
	"pagination_produits/one" : 'produit',
	"pagination_souscats" : 'catégories',
	"pagination_souscats/one" : 'catégorie',
	"pagination_elts" : 'éléments',
	"pagination_elts/one" : 'élément',
	"pagination_aucun_element" : 'Nous sommes désolés mais aucun article ne correspond à votre sélection',
	"wishlist_aucun_element" : 'Vous n\'avez aucune liste de produits préférés',
	"search_aucun_element" : 'Aucun produit ne semble correspondre à votre recherche.',
	"search_aucun_element_bis" : 'Nous vous proposons nos meilleures ventes :',
	"option_tri_top" : 'Popularité',
	"option_tri_moyavis" : 'Avis clients',
	"option_tri_nomaz" : 'Nom A->Z',
	"option_tri_nomza" : 'Nom Z->A',
	"option_tri_prixasc" : 'Prix le + bas',
	"option_tri_prixdesc" : 'Prix le + élevé',
	"option_tri_rank" : 'Pertinence',
	"option_tri_pctreduc" : '% de Réduction',
	"option_tri_datedesc" : 'Le plus récent',
	"option_tri_dateasc" : 'Le plus ancien',
	"option_tri_qteasc" : 'Stock -',
	"option_tri_qtedesc" : 'Stock +',
	"option_tri_margeasc" : '% Marge -',
	"option_tri_margedesc" : '% Marge +',
	"type" : {
		"nouveaute" : 'Nouveautés',
		"promotion" : 'Promotions',
		"bonneAffaire" : 'Bonnes Affaires',
		"destockage" : 'Coup de cœur',
		"retourStock" : 'De retour en stock'
	},
	"search_yoursearch" : 'Les résultats pour',
	"search_didyoumean" : 'Vouliez-vous plutôt dire {0} ?',
	"search_partiel" : 'Ces produits correspondent à certains de vos mots clés',
	"search_partiel_like" : 'Ces résultats peuvent correspondre à certains de vos mots clés :',
	"search_default" : 'recherche mot cle',
	"panier_offre_speciale" : 'CADEAU OFFERT',
	"panier_offre_speciale_change" : 'Changer d\'offre',
	"panier_frais_traitement" : 'Frais de traitement',
	"panier_cgv" : 'Vous devez lire et accepter les conditions générales de vente',
	"panier_cb" : 'Paiement CB',
	"panier_cb_montant" : 'Montant de votre commande : ',
	"panier_cb_texte" : 'Connexion au paiement sécurisé<br/>Merci de patienter...',
	"attribut_listCategories" : 'Catégories',
	"attribut_filtres" : 'Affiner votre recherche',
	"attribut_all" : 'Aucun filtre',
	"filtre_age" : 'Recherche de produit par tranche d\'âge',
	"tranche_ageMM" : 'de %1$s à %2$s mois',
	"tranche_ageMY" : 'de %1$s mois à %2$s ans',
	"tranche_ageYY" : 'de %1$s à %2$s ans',
	"tranche_ageYPlus" : 'pour les plus de %1$s ans',
	"mois" : 'mois',
	"ans" : 'ans',
	"ans/one" : 'an',
	"paiement" : {
		"CG" : 'Virement',
		"VIR" : 'Virement',
		"CHQ" : 'Chèque',
		"MDC" : 'Mandat Cash',
		"MDA" : 'Mandat Administratif',
		"CHQ3X" : 'Chèque 3X',
		"CHQ2X" : 'Chèque 2X',
		"CB" : 'Carte Bancaire',
		"KADEOS" : 'Chèque cadeau KADEOS',
		"CADHOC" : 'Chèque cadeau CADHOC',
		"CADO" : 'Chèque cadeau CADO',
		"TIRGROUPE" : 'Chèque cadeau TIRGROUPE',
		"CHQLUDENDO" : 'Chèque salarié Ludendo',
		"PP" : 'PayPal',
		"EXT" : 'Externe',
		"RP" : 'ReceiveAndPay EN UNE FOIS par carte bancaire',
		"RP3X" : 'ReceiveAndPay EN PLUSIEURS FOIS, avec l\'option de crédit',
		"PM" : 'Porte monnaie'
	},
	"name_paiement" : {
		"9" : 'cb',
		"10" : 'paypal',
		"1" : 'cheque',
		"4" : 'cheque2x',
		"14" : 'cheque3x',
		"60" : 'chequekdo',
		"2" : 'virement',
		"3" : 'mandatcash',
		"6" : 'mandatadmin'
	},
	"text_paiement" : {
		"9" : 'Carte',
		"10" : 'Paypal',
		"1" : 'Chèque',
		"4" : 'Chèque 2x',
		"14" : 'Chèque 3x',
		"60" : 'Chèque cadeau',
		"2" : 'Virement',
		"3" : 'Mandat',
		"6" : 'Mandat administratif'
	},
	"label_paiement" : {
		"9" : 'Carte Bancaire',
		"10" : 'Paypal',
		"1" : 'Chèque',
		"4" : 'Chèque 2x',
		"14" : 'Chèque 3x',
		"60" : 'Chèque cadeau',
		"2" : 'Virement Bancaire',
		"3" : 'Mandat Cash',
		"6" : 'Mandat administratif'
	},
	"description_paiement" : {
		"9" : '',
		"10" : '',
		"1" : 'Vos chèques doivent émaner d\'un établissement bancaire situé sur le territoire français . Ils doivent être libellé à l\'ordre d\' Avenue des jeux .<br > La validation de votre commande et son expédition se font à réception de votre règlement.',
		"4" : 'Vos chèques doivent émaner d\'un établissement bancaire situé sur le territoire français . Ils doivent être libellé à l\'ordre d\' Avenue des jeux .<br > La validation de votre commande et son expédition se font à réception de votre règlement.',
		"14" : 'Vos chèques doivent émaner d\'un établissement bancaire situé sur le territoire français . Ils doivent être libellé à l\'ordre d\' Avenue des jeux .<br > La validation de votre commande et son expédition se font à réception de votre règlement.',
		"60" : '* Nous n\'acceptons pas les cartes cadeaux, les chèques Kadeos Culture (bleu).<br>Le complément est à régler par chèque bancaire à l\'ordre d\' Avenue des jeux.<br>La validation et l\'expédition se font à réception de votre règlement.',
		"2" : 'Concluez rapidement vos achats en optant pour le paiement par virement. La validation de votre commande et son expédition se font à réception de votre règlement.',
		"3" : 'Votre commande sera validée et expédiée dès réception du montant de votre facture.',
		"6" : 'Réservé aux administrations. Votre commande sera expédiée après réception de la preuve d\'engagement de paiement par mandat administratif.'
	},
	"cheque_cadeau" : {
		"61" : 'Cadhoc',
		"60" : 'Kadeos *',
		"62" : 'Tir Groupé',
		"63" : 'CA DO',
		"64" : 'Chèque Salarié Ludendo'
	},
	"modep_RP_descriptif" : 'Vous commandez aujourd\'hui et vous n\'êtes débité qu\'APRES avoir reçu et vérifié votre commande, en une fois par carte bancaire (compatible VISA, CB et Mastercard). ReceiveAndPay est un service FIA-NET 100 % sécurisé, et totalement gratuit pour vous.',
	"modep_RP3X_descriptif" : 'Vous commandez aujourd\'hui et vous n\'êtes débité en plusieurs fois qu\'APRES avoir reçu et vérifié votre commande. Ce paiement nécessite l\'ouverture d\'une réserve de crédit auprès de notre partenaire Sofinco. Celle-ci se fait très simplement en ligne après le choix de votre barème et une réponse de principe en temps réel. ReceiveAndPay est un service FIA-NET 100 % sécurisé et totalement gratuit pour vous.',
	"etape4_choix_chqkdo" : 'Vous devez choisir un type de chèque cadeau',
	"etape4_montant_chqkdo" : 'Vous devez indiquer le montant total du ou des chèques cadeau',
	"etape4_montant_chqkdo999" : 'Vous devez indiquer un montant total inférieur à 999EUR',
	"etape4_err_montant_chqkdo" : 'Le montant total du ou des chèques cadeau est incorrect',
	"blogCategorie" : {
		"c1" : 'Nos tutos & DIY',
		"c2" : 'Les actualités du jouet',
		"c3" : 'Nos tests produits',
		"c4" : 'Notre actu',
		"c5" : 'Les fiches conseils',
		"c6" : 'Les guides d\'achat',
		"c7" : 'Les conseils et astuces',
		"c8" : 'Les actualités du moment'
	},
	"facture_titre" : 'Facture {0} du {1}',
	"devis_titre" : 'Devis {0} du {1}',
	"facture_refclient" : 'Référence client',
	"facture_adrf" : 'Adresse de facturation',
	"facture_adrl" : 'Adresse de livraison',
	"facture_nom" : 'Prénom Nom',
	"facture_soc" : 'Société',
	"facture_adr" : 'Adresse',
	"facture_tel" : 'Téléphone',
	"facture_cp" : 'CP',
	"facture_ville" : 'Ville',
	"facture_pays" : 'Pays',
	"facture_detail" : 'Détail de la commande',
	"facture_ref" : 'Référence produit',
	"facture_des" : 'Désignation',
	"facture_qte" : 'Qte',
	"facture_pu" : 'P.U HT',
	"facture_tva" : 'TVA',
	"facture_px" : 'Prix',
	"facture_fp" : 'Frais de port',
	"facture_ft" : 'Frais de traitement',
	"facture_remise" : 'Remise',
	"facture_to" : 'Total',
	"facture_donttva" : 'dont TVA {0} %',
	"facture_reglement" : 'Date de règlement',
	"facture_modep" : 'Mode de paiement',
	"log_client_produits" : 'Produits consultés',
	"no_article" : '0',
	"x_article" : '%d',
	"x_articles" : '%d',
	"x_article_euros" : '%d',
	"x_articles_euros" : '%d',
	"ariane_accueil" : 'Accueil',
	"ariane_blog" : 'Le blog',
	"recrut_invalidForm" : 'Erreur : Vous devez fournir 1 fichier CV, 1 fichier lettre de motivation et votre adresse Email',
	"recrut_problemeTechnique" : 'Erreur : Problème technique',
	"recrut_invalidCaptcha" : 'Erreur : Le code de 2 chiffres ne correspond pas.',
	"recrut_mailOK" : 'Merci de votre candidature. Votre CV et lettre de motivation nous ont été transmis. Nous prendrons prochainement contact avec vous.',
	"pp_sauve_panier" : 'Attention ! Les puzzles personnalisés ne sont pas sauvegardés !',
	"pp_js_maxfiles" : 'Vous ne pouvez charger plus de 6 images !',
	"pp_js_upload1" : 'Cliquez sur le bouton "Parcourir" et choisissez votre photo (format JPG, 20 Mo maximum).',
	"pp_js_upload2" : 'Le téléchargement de votre photo commence automatiquement.',
	"pp_js_upload_bt" : 'Choisir une image',
	"pp_js_upload_start" : 'Téléchargement en cours...',
	"pp_js_upload_cancel" : 'Annuler',
	"pp_js_prepa" : 'Préparation de la photo',
	"pp_js_errformat" : 'Votre image n\'est pas au format JPG',
	"pp_js_postal_titre" : 'Pour commander un puzzle personnalisé à partir d\'un tirage papier',
	"pp_js_postal_1" : 'Choisissez des photos ayant une taille maximum de 20 x 30 cm et minimum de 10 x 13 cm.',
	"pp_js_postal_2" : 'Ne nous envoyez jamais de négatifs ni de diapositives. En cas de perte ils sont irremplaçables. La photographie que vous nous envoyez passera par un scanner et sera recadrée aux dimensions appropriées à la confection du puzzle. Si la photo nécéssite un recadrage important, nous vous contacterons pour vous faire une proposition.',
	"pp_js_postal_3" : 'Pour commander, choisissez le nombre d\'exemplaires du puzzle à réaliser à partir de votre photo, cocher la case "Je paierai ma commande par chèque..." et cliquez sur le bouton "Ajouter au panier".',
	"pp_js_faq" : 'Consultez la FAQ pour plus de renseignements',
	"pp_js_postal_check" : 'Je paierai ma commande par chèque et je joindrai la photo papier.',
	"pp_js_qte" : 'Quantité',
	"pp_js_postal_close" : 'Fermer la fenêtre',
	"pp_js_erreur" : 'Erreur de traitement',
	"pp_js_cgv" : 'Je certifie que l\'image n\'est pas protégée par des droits d\'auteur ou que je possède ces droits.',
	"pp_js_badq" : 'La qualité de l\'image n\'est pas suffisante',
	"pp_js_droits" : 'Vous devez certifier que l\'image n\'est pas protégée par des droitsd\'auteur ou que vous possédez ces droits.',
	"pp_js_nophoto" : 'Vous devez choisir une photo',
	"pp_js_cheq" : 'Vous devez cocher la case \'Je paierai ma commande par chèque...\'',
	"pp_js_format" : 'Vous devez choisir un format',
	"pp_js_encours" : 'Opération en cours',
	"pp_title" : 'Vos photos préférées en puzzle personnalisé !',
	"pp_titleformat" : 'Choisissez votre format',
	"pp_titleddl" : 'Téléchargez votre photo',
	"pp_titlefinal" : 'Finalisez votre puzzle',
	"pp_mesimages" : 'MES IMAGES',
	"pp_faq" : 'Foire aux questions (Mode d\'emploi, délai...) &gt;&gt;',
	"pp_delai" : 'Délai de réalisation : 10 à 15 jours.',
	"pp_postal" : 'Je préfère envoyer la photo originale par courrier',
	"pp_q" : 'Qualité d\'image insuffisante. Agrandissez votre sélection ou téléchargez une image plus grande.',
	"pp_modepo" : 'Mode portrait déjà actif !',
	"pp_modepa" : 'Mode paysage déjà actif !',
	"pp_dimensions" : 'Dimensions du puzzle assemblé',
	"pp_environ" : 'environ',
	"pp_nbp" : 'Nombre de pièces',
	"pp_emballage" : 'Pour un cadeau encore plus réussi, la photo de votre puzzle est présente sur la boîte du puzzle : vous pourrez ainsi disposer d\'un modèle pour sa réalisation.',
	"pp_emballage_pack" : 'Avec cette offre, vous recevrez vos puzzles personnalisés sous film plastique.',
	"left_plus" : 'Plus ...',
	"left_plus_close" : 'Fermer - X',
	"left_plus_titre" : 'Nos',
	"sendFriend_err1" : 'Vous devez renseigner au moins un(e) ami(e)',
	"sendFriend_err2" : 'Votre adresse e-mail n\'est pas valide',
	"sendFriend_err3" : 'Vous devez renseigner votre nom et votre adresse e-mail',
	"mavertir_err1" : 'Votre adresse e-mail n\'est pas valide',
	"mavertir_err2" : 'Vous devez renseigner votre adresse e-mail',
	"libellecodepromo" : 'Journée à -{0}%',
	"setpromoday_update" : 'C\'est noté !<br />Le %1$s vous bénéficierez bien de -%2$s% sur votre commande. <br />Au jour j, et une fois votre commande validée, son montant <br />sera automatiquement remisé de %2$s%. Pas besoin de code de réduction !',
	"setpromoday_err1" : 'La date renseignée semble incorrecte',
	"setpromoday_err2" : 'La date renseignée ne semble pas être correcte',
	"setpromoday_err3" : 'L\'offre préferentielle n\'est malheureusement<br /> pas applicable en période de Noël.<br /><br /> Merci d\'en choisir une nouvelle.',
	"setpromoday_err4" : 'L\'offre préferentielle n\'est malheureseument<br /> pas applicable en période de Soldes.<br /><br /> Merci d\'en choisir une nouvelle.',
	"prenomchild_err" : 'Quel est le prénom de votre enfant ?',
	"ddnchild_err" : 'La date de naissance renseignée semble incorrecte',
	"sexechild_err" : 'Est-ce une fille, un garçon ?',
	"linkchild_err" : 'Quel est votre lien de parenté avec cet enfant ?',
	"status_enregistrement" : 'Votre commande a bien été prise en compte.',
	"status_validation" : 'Votre paiement a bien été validé.',
	"status_preparation" : 'Votre commande est en cours de préparation.',
	"status_expedition" : 'Votre commande a été expédiée.',
	"status_livraison" : 'Votre commande est livrée.',
	"conditionGenerale" : {
		"1" : 'Conditions générales de ventes particuliers',
		"2" : 'Conditions d\'utilisation',
		"3" : 'Politique de confidentialité',
		"4" : 'Mentions Légales',
		"5" : 'Conditions générales de vente Comités d\'entreprise',
		"6" : 'Conditions générales de vente Collectivités',
		"7" : 'Qui sommes-nous ?',
		"8" : 'Livraison',
		"all" : 'Conditions générales de vente (particuliers, Comités d\'entreprise, Collectivités)'
	},
	"pageStatique" : {
		"aide" : 'Aide en ligne',
		"delivery" : 'Frais et délais de livraison',
		"codesPromo" : 'Codes de réduction et offres promotionnelles',
		"newsletter" : 'Abonnement à la newsletter',
		"offres_entreprises" : 'Comité d\'entreprise',
		"offres_collectivites" : 'Collectivité',
		"offres_collectivites_entreprises" : 'Comités d\'entreprise et Collectivités',
		"offresPromotionnelles" : 'Nos offres de remboursement',
		"plan" : 'Plan du site',
		"presse" : 'Espace Presse',
		"recrutement" : 'Recrutement',
		"recrutement_form" : 'Recrutement',
		"retractation" : 'Me rétracter',
		"product_callback" : 'Rappels produits'
	},
	"dateName" : {
		"beforeYesterday" : 'avant-hier',
		"yesterday" : 'hier',
		"today" : 'aujourd\'hui',
		"tomorrow" : 'demain',
		"afterTomorrow" : 'après-demain'
	},
	"openingHours" : 'du {0} au {1} de {2} à {3}',
	"sav" : {
		"selectOrder" : 'Sélectionnez la commande associée à votre demande',
		"orderNb" : 'Commande n°{0} du {1} ({2} €)'
	},
	"uplineSav" : {
		"businessDayBefore" : ' Vous pouvez nous joindre aujourd\'hui dès 09h00 au <strong>%1$s</strong>.',
		"businessDayDuring" : '<strong>Vous avez une question ?</strong> Vous pouvez nous joindre aujourd\'hui de 9h à 12h30 au <strong>%1$s</strong>.',
		"businessDayBeforeSpecialChristmas" : '<strong>Vous avez une question ?</strong> Vous pouvez nous joindre aujourd\'hui dès 09h00 au <strong>%1$s</strong>.',
		"businessDayDuringSpecialChristmas" : '<strong>Vous avez une question ?</strong> Vous pouvez nous joindre aujourd\'hui de 9h à 12h30 au <strong>%1$s</strong>.',
		"businessDayDuringSaturdaySpecialChristmas" : '<strong>Vous avez une question ?</strong> Vous pouvez nous joindre aujourd\'hui de 9h à 12h30 au <strong>%1$s</strong>.',
		"businessDayBeforeSpecialAfterChristmas" : '<strong>Vous avez une question ?</strong> Vous pouvez nous joindre aujourd\'hui dès 09h00 au <strong>%1$s</strong>.',
		"businessDayDuringSpecialAfterChristmas" : '<strong>Vous avez une question ?</strong> Vous pouvez nous joindre aujourd\'hui de 9h à 12h30 au <strong>%1$s</strong>.',
		"nextBusinessDay" : '<strong>Vous avez une question ?</strong> Nous serons de retour %2$s dès 9h00 au <strong>%1$s</strong>.',
		"tomorrow" : 'demain',
		"afterTomorrow" : 'après-demain'
	},
	"monthFr" : {
		"1" : 'Janvier',
		"2" : 'Février',
		"3" : 'Mars',
		"4" : 'Avril',
		"5" : 'Mai',
		"6" : 'Juin',
		"7" : 'Juillet',
		"8" : 'Août',
		"9" : 'Septembre',
		"10" : 'Octobre',
		"11" : 'Novembre',
		"12" : 'Décembre'
	},
	"uplineShipping" : {
		"today" : 'Envoyé aujourd\'hui',
		"otherDay" : 'Envoyé {0}',
		"dropshipping" : 'Livraison sous 2 semaines'
	},
	"listingHeaderDefaultTitreH1" : {
		"nouveautes" : 'Nouveautés jeux et jouets',
		"promotions" : 'Jeux et jouets en promotions',
		"soldes" : 'Jeux et jouets en soldes',
		"topSale" : 'Les meilleurs jouets',
		"destockage" : 'Déstockage jeux et jouets'
	},
	"listingHeaderDefaultTitre" : {
		"nouveautes" : 'Nouveautés Jouets',
		"promotions" : 'Promotions Jouets',
		"soldes" : 'Soldes Jouets',
		"marques" : 'Toutes les Marques',
		"topSale" : 'Les meilleures ventes de Jouets et Jeux',
		"destockage" : 'Déstockage jeux et jouets pour enfants',
		"odr" : ''
	},
	"listingHeaderDefaultDesc" : {
		"nouveautes" : 'Retrouvez ici toutes les nouveautés du moment pour les enfants dès le 1er âge. Un large choix de références tendances vous est proposé pour que vous puissiez trouver le jouet ou le jeu idéal pour votre enfant. <br>Faites sensation auprès de votre petite fille ou de votre petit garçon en lui offrant les dernières créations des plus célèbres marques. Smoby, Crayola, Playmobil, Djeco, Asmodée, etc., voici quelques-unes des marques que vous trouverez sur cette page. Découvrez aussi les personnages préférés de vos enfants sous forme de licences tendances. <br>Quel que soit le centre d’intérêt de votre enfant et son âge, vous trouverez ce qui lui fera plaisir et les jeux et jouets les plus adaptés pour lui. Faites plaisir à votre enfant avec un jeu de société, un jeu de loisir créatif, un jeu d’éveil, une figurine pour compléter une collection, un jouet en bois, un jeu de plein air, un jeu d’imitation, une console ou encore une poupée. <br>Si vous êtes en manque d’idées, ne cherchez plus et sélectionnez votre cadeau sur notre page spéciale « nouveautés ».',
		"promotions" : 'Retrouvez ici toutes les promotions du moment pour faire plaisir à vos enfants à petits prix. Découvrez toutes vos marques préférées en promotion à offrir à n’importe quel moment de l’année. Profitez de prix exceptionnels sur des jeux d’éveil, des jeux de société, des jeux de loisirs créatifs, des consoles de jeux, des jeux de plein air ou encore des jeux de construction. Faites le plein de cadeaux à prix réduits et comblez votre petite fille ou votre petit garçon avec des jouets de qualité et tendances ! Quel que soit l’âge de votre petit bout de chou, vous trouverez forcément le jouet idéal répondant à ses besoins et qui lui fera plaisir en même temps. Bénéficiez de belles remises sur une large sélection de produits et gâtez vos enfants ! ',
		"soldes" : 'A vos soldes, prêt, partez ! Les soldes jouets et jeux, c’est maintenant ! Vos soldes sont expédiés le jour même si vous commandez avant 12h00 (hors week-end) et sont livrés GRATUITEMENT dès 59 euros seulement (voir conditions) ! Alors, plus d’h&eacute;sitation, c’est sur Avenue des jeux que vous ferez les plus belles affaires ! Profitez du meilleur des <a href="https:///promotions.html?s=2&mar=21">soldes Playmobil</a>, a href="https:///promotions.html?s=2&mar=1">soldes LEGO</a>, <a href="https:///promotions.html?s=2&mar=15">soldes Vtech</a> et <a href="https:///promotions.html?s=2&mar=89">soldes Corolle</a> ! Jouets en bois, poupées, jeux d’imitation, jeux de loisirs créatifs, jeux de plein air ou les figurines, ils sont tous au rendez-vous pour faire plaisir à petit prix.',
		"marques" : 'Pour satisfaire les enfants comme les parents, vous retrouverez ici toutes les belles marques de jouet que notre site propose. Elles sont classées par ordre alphabétique et vous pourrez ainsi trouver la marque que vous cherchez facilement. Nous vous proposons environ 400 marques de jouets différentes. Elles sont donc très variées et correspondent aux attentes de chacun. Nous avons tous une marque qui nous attend sur ce site. Cette fameuse marque qui saura combler les attentes de l’enfant mais également celles des parents. N’hésitez pas, et consultez notre grande liste de marques, qui proposent toutes, des jouets et accessoires de qualité !',
		"topSale" : 'Retrouvez ici le fidèle top vente de notre site ! Il vous indique les jouets qui sont les plus achetés sur Avenue Des Jeux et surtout, les jouets les plus désirés par les enfants. Il est un très bon indicateur des tendances du moment. Vous avez un doute sur un jouet à acheter ? Avec le top vente, il est impossible que vous fassiez le mauvais choix. Exit les cadeaux ratés. Désormais, vous ne pourrez que trouver le cadeau idéal pour un enfant. Que ce soit pour un garçon ou pour une fille, le top vente vous propose des références de jouets de tout âge divers et variés. ',
		"destockage" : 'Venez découvrir notre sélection de jeux et jouets en déstockage ! Livraison en 24/48h',
		"odr" : ''
	},
	"defaultIntroduction" : {
		"categorie" : 'Retrouvez toute notre gamme de {0} ! Les jeux et jouets de cet univers émerveilleront vos enfants à coup sûr !',
		"attribut" : 'Plongez dans l\'univers des jeux et jouets {0} ! Pour les petits comme les plus grands, les jouets {0} émerveilleront vos enfants.'
	},
	"categorieChildrenSEO" : {
		"intro" : 'A découvrir aussi dans l\'univers {0} : ',
		"item" : '<a href="{0}" title="{2}">{1}</a>, ',
		"last" : 'et <a href="{0}" title="{2}">{1}</a>.'
	},
	"facture_surplus_kdo" : 'Surplus chèque cadeau',
	"codePromoDiscountAmount" : {
		"1" : '-{0}%',
		"2" : '-{0}€',
		"3" : '',
		"5" : '',
		"6" : '',
		"7" : '-{0}%',
		"8" : '',
		"9" : '',
		"10" : '-{0}%',
		"11" : '',
		"12" : '',
		"14" : '-{0}€'
	},
	"codePromoDiscountText" : {
		"1" : 'Remise immédiate',
		"2" : 'Remise immédiate',
		"3" : 'Livraison Offerte',
		"5" : 'Produit Offert',
		"6" : 'Offre spéciale',
		"7" : '',
		"8" : '',
		"9" : 'Produit Offert sous conditions',
		"10" : '',
		"11" : '',
		"12" : 'Produit Offert avec remise',
		"14" : 'Pour 50€'
	},
	"__pluralRules" : {
		"comments" : 'http://cldr.unicode.org/index/downloads/cldr-24',
		"ar" : {
			"zero" : 'n==0',
			"one" : 'n==1',
			"two" : 'n==2',
			"few" : '(n % 100>=3 && n % 100<=10)',
			"many" : '(n % 100>=11 && n % 100<=99)'
		},
		"he" : {
			"one" : 'i==1 && v==0',
			"two" : 'i==2 && v==0',
			"many" : 'v==0 && (n>0 && n<10) && n % 10==0'
		},
		"iw" : {
			"one" : 'i==1 && v==0',
			"two" : 'i==2 && v==0',
			"many" : 'v==0 && (n>0 && n<10) && n % 10==0'
		},
		"af" : {
			"one" : 'n==1'
		},
		"asa" : {
			"one" : 'n==1'
		},
		"ast" : {
			"one" : 'n==1'
		},
		"az" : {
			"one" : 'n==1'
		},
		"bem" : {
			"one" : 'n==1'
		},
		"bez" : {
			"one" : 'n==1'
		},
		"bg" : {
			"one" : 'n==1'
		},
		"brx" : {
			"one" : 'n==1'
		},
		"cgg" : {
			"one" : 'n==1'
		},
		"chr" : {
			"one" : 'n==1'
		},
		"ckb" : {
			"one" : 'n==1'
		},
		"dv" : {
			"one" : 'n==1'
		},
		"ee" : {
			"one" : 'n==1'
		},
		"el" : {
			"one" : 'n==1'
		},
		"eo" : {
			"one" : 'n==1'
		},
		"es" : {
			"one" : 'n==1'
		},
		"eu" : {
			"one" : 'n==1'
		},
		"fo" : {
			"one" : 'n==1'
		},
		"fur" : {
			"one" : 'n==1'
		},
		"fy" : {
			"one" : 'n==1'
		},
		"gsw" : {
			"one" : 'n==1'
		},
		"ha" : {
			"one" : 'n==1'
		},
		"haw" : {
			"one" : 'n==1'
		},
		"hu" : {
			"one" : 'n==1'
		},
		"jgo" : {
			"one" : 'n==1'
		},
		"jmc" : {
			"one" : 'n==1'
		},
		"ka" : {
			"one" : 'n==1'
		},
		"kaj" : {
			"one" : 'n==1'
		},
		"kcg" : {
			"one" : 'n==1'
		},
		"kk" : {
			"one" : 'n==1'
		},
		"kkj" : {
			"one" : 'n==1'
		},
		"kl" : {
			"one" : 'n==1'
		},
		"ks" : {
			"one" : 'n==1'
		},
		"ksb" : {
			"one" : 'n==1'
		},
		"ku" : {
			"one" : 'n==1'
		},
		"ky" : {
			"one" : 'n==1'
		},
		"lb" : {
			"one" : 'n==1'
		},
		"lg" : {
			"one" : 'n==1'
		},
		"mas" : {
			"one" : 'n==1'
		},
		"mgo" : {
			"one" : 'n==1'
		},
		"ml" : {
			"one" : 'n==1'
		},
		"mn" : {
			"one" : 'n==1'
		},
		"nah" : {
			"one" : 'n==1'
		},
		"nb" : {
			"one" : 'n==1'
		},
		"nd" : {
			"one" : 'n==1'
		},
		"ne" : {
			"one" : 'n==1'
		},
		"nn" : {
			"one" : 'n==1'
		},
		"nnh" : {
			"one" : 'n==1'
		},
		"no" : {
			"one" : 'n==1'
		},
		"nr" : {
			"one" : 'n==1'
		},
		"ny" : {
			"one" : 'n==1'
		},
		"nyn" : {
			"one" : 'n==1'
		},
		"om" : {
			"one" : 'n==1'
		},
		"or" : {
			"one" : 'n==1'
		},
		"os" : {
			"one" : 'n==1'
		},
		"pap" : {
			"one" : 'n==1'
		},
		"ps" : {
			"one" : 'n==1'
		},
		"rm" : {
			"one" : 'n==1'
		},
		"rof" : {
			"one" : 'n==1'
		},
		"rwk" : {
			"one" : 'n==1'
		},
		"saq" : {
			"one" : 'n==1'
		},
		"seh" : {
			"one" : 'n==1'
		},
		"sn" : {
			"one" : 'n==1'
		},
		"so" : {
			"one" : 'n==1'
		},
		"sq" : {
			"one" : 'n==1'
		},
		"ss" : {
			"one" : 'n==1'
		},
		"ssy" : {
			"one" : 'n==1'
		},
		"st" : {
			"one" : 'n==1'
		},
		"syr" : {
			"one" : 'n==1'
		},
		"ta" : {
			"one" : 'n==1'
		},
		"te" : {
			"one" : 'n==1'
		},
		"teo" : {
			"one" : 'n==1'
		},
		"tig" : {
			"one" : 'n==1'
		},
		"tk" : {
			"one" : 'n==1'
		},
		"tn" : {
			"one" : 'n==1'
		},
		"tr" : {
			"one" : 'n==1'
		},
		"ts" : {
			"one" : 'n==1'
		},
		"uz" : {
			"one" : 'n==1'
		},
		"ve" : {
			"one" : 'n==1'
		},
		"vo" : {
			"one" : 'n==1'
		},
		"vun" : {
			"one" : 'n==1'
		},
		"wae" : {
			"one" : 'n==1'
		},
		"xh" : {
			"one" : 'n==1'
		},
		"xog" : {
			"one" : 'n==1'
		},
		"ak" : {
			"one" : '(n>=0 && n<=1)'
		},
		"bh" : {
			"one" : '(n>=0 && n<=1)'
		},
		"guw" : {
			"one" : '(n>=0 && n<=1)'
		},
		"ln" : {
			"one" : '(n>=0 && n<=1)'
		},
		"mg" : {
			"one" : '(n>=0 && n<=1)'
		},
		"nso" : {
			"one" : '(n>=0 && n<=1)'
		},
		"pa" : {
			"one" : '(n>=0 && n<=1)'
		},
		"ti" : {
			"one" : '(n>=0 && n<=1)'
		},
		"wa" : {
			"one" : '(n>=0 && n<=1)'
		},
		"ff" : {
			"one" : '(i==0 || i==1)'
		},
		"fr" : {
			"one" : '(i==0 || i==1)'
		},
		"hy" : {
			"one" : '(i==0 || i==1)'
		},
		"kab" : {
			"one" : '(i==0 || i==1)'
		},
		"lv" : {
			"zero" : 'n % 10==0 || (n % 100>=11 && n % 100<=19) || v==2 && (f % 100>=11 && f % 100<=19)',
			"one" : 'n % 10==1 && n % 100 != 11 || v==2 && f % 10==1 && f % 100 != 11 || v != 2 && f % 10==1'
		},
		"iu" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"kw" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"naq" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"se" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"sma" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"smi" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"smj" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"smn" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"sms" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"ga" : {
			"one" : 'n==1',
			"two" : 'n==2',
			"few" : '(n>=3 && n<=6)',
			"many" : '(n>=7 && n<=10)'
		},
		"mo" : {
			"one" : 'i==1 && v==0',
			"few" : 'v != 0 || n==0 || n != 1 && (n % 100>=1 && n % 100<=19)'
		},
		"ro" : {
			"one" : 'i==1 && v==0',
			"few" : 'v != 0 || n==0 || n != 1 && (n % 100>=1 && n % 100<=19)'
		},
		"lt" : {
			"one" : 'n % 10==1 && (n % 100>11 && n % 100<19)',
			"few" : '(n % 10>=2 && n % 10<=9) && (n % 100>11 && n % 100<19)',
			"many" : 'f != 0'
		},
		"be" : {
			"one" : 'n % 10==1 && n % 100 != 11',
			"few" : '(n % 10>=2 && n % 10<=4) && (n % 100>12 && n % 100<14)',
			"many" : 'n % 10==0 || (n % 10>=5 && n % 10<=9) || (n % 100>=11 && n % 100<=14)'
		},
		"cs" : {
			"one" : 'i==1 && v==0',
			"few" : '(i>=2 && i<=4) && v==0',
			"many" : 'v != 0'
		},
		"sk" : {
			"one" : 'i==1 && v==0',
			"few" : '(i>=2 && i<=4) && v==0',
			"many" : 'v != 0'
		},
		"pl" : {
			"one" : 'i==1 && v==0',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14)',
			"many" : 'v==0 && i != 1 && (i % 10>=0 && i % 10<=1) || v==0 && (i % 10>=5 && i % 10<=9) || v==0 && (i % 100>=12 && i % 100<=14)'
		},
		"sl" : {
			"one" : 'v==0 && i % 100==1',
			"two" : 'v==0 && i % 100==2',
			"few" : 'v==0 && (i % 100>=3 && i % 100<=4) || v != 0'
		},
		"mt" : {
			"one" : 'n==1',
			"few" : 'n==0 || (n % 100>=2 && n % 100<=10)',
			"many" : '(n % 100>=11 && n % 100<=19)'
		},
		"mk" : {
			"one" : 'v==0 && i % 10==1 || f % 10==1'
		},
		"cy" : {
			"zero" : 'n==0',
			"one" : 'n==1',
			"two" : 'n==2',
			"few" : 'n==3',
			"many" : 'n==6'
		},
		"lag" : {
			"zero" : 'n==0',
			"one" : '(i==0 || i==1) && n != 0'
		},
		"shi" : {
			"one" : 'i==0 || n==1',
			"few" : '(n>=2 && n<=10)'
		},
		"br" : {
			"one" : 'n % 10==1 && n % 100 != 11 && n % 100 != 71 && n % 100 != 91',
			"two" : 'n % 10==2 && n % 100 != 12 && n % 100 != 72 && n % 100 != 92',
			"few" : '(n % 10>=3 && n % 10<=4),9 && ((n % 100>10 && n % 100<19) || (n % 100>70 && n % 100<79) || (n % 100>90 && n % 100<99))',
			"many" : 'n != 0 && n % 1000000==0'
		},
		"ksh" : {
			"zero" : 'n==0',
			"one" : 'n==1'
		},
		"tzm" : {
			"one" : '(n>=0 && n<=1) || (n>=11 && n<=99)'
		},
		"gv" : {
			"one" : 'n % 10==1',
			"two" : 'n % 10==2',
			"few" : '(n % 100==0 || n % 100==20 || n % 100== 40 || n % 100== 60)'
		},
		"gd" : {
			"one" : '(n==1 || n==11)',
			"two" : '(n==2 || n==12)',
			"few" : '(n>=3 && n<=10) || (n>=13 && n<=19)'
		},
		"fil" : {
			"one" : '(i>=0 && i<=1) && v==0'
		},
		"tl" : {
			"one" : '(i>=0 && i<=1) && v==0'
		},
		"ca" : {
			"one" : 'i==1 && v==0'
		},
		"de" : {
			"one" : 'i==1 && v==0'
		},
		"en" : {
			"one" : 'i==1 && v==0'
		},
		"et" : {
			"one" : 'i==1 && v==0'
		},
		"fi" : {
			"one" : 'i==1 && v==0'
		},
		"gl" : {
			"one" : 'i==1 && v==0'
		},
		"it" : {
			"one" : 'i==1 && v==0'
		},
		"ji" : {
			"one" : 'i==1 && v==0'
		},
		"nl" : {
			"one" : 'i==1 && v==0'
		},
		"sv" : {
			"one" : 'i==1 && v==0'
		},
		"sw" : {
			"one" : 'i==1 && v==0'
		},
		"ur" : {
			"one" : 'i==1 && v==0'
		},
		"yi" : {
			"one" : 'i==1 && v==0'
		},
		"pt" : {
			"one" : 'i==1 && v==0 || i==0 && t==1'
		},
		"da" : {
			"one" : 'n==1 || t != 0 && (i==0 || i==1)'
		},
		"pt_PT" : {
			"one" : 'n==1 && v==0'
		},
		"am" : {
			"one" : 'i==0 || n==1'
		},
		"bn" : {
			"one" : 'i==0 || n==1'
		},
		"fa" : {
			"one" : 'i==0 || n==1'
		},
		"gu" : {
			"one" : 'i==0 || n==1'
		},
		"hi" : {
			"one" : 'i==0 || n==1'
		},
		"kn" : {
			"one" : 'i==0 || n==1'
		},
		"mr" : {
			"one" : 'i==0 || n==1'
		},
		"zu" : {
			"one" : 'i==0 || n==1'
		},
		"is" : {
			"one" : 't==0 && i % 10==1 && i % 100 != 11 || t != 0'
		},
		"si" : {
			"one" : '(n==0 || n==1) || i==0 && f==1'
		},
		"bs" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11 || f % 10==1 && f % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14) || (f % 10>=2 && f % 10<=4) && (f % 100>12 && f % 100<14)'
		},
		"hr" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11 || f % 10==1 && f % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14) || (f % 10>=2 && f % 10<=4) && (f % 100>12 && f % 100<14)'
		},
		"sh" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11 || f % 10==1 && f % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14) || (f % 10>=2 && f % 10<=4) && (f % 100>12 && f % 100<14)'
		},
		"sr" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11 || f % 10==1 && f % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14) || (f % 10>=2 && f % 10<=4) && (f % 100>12 && f % 100<14)'
		},
		"ru" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11',
			"many" : 'v==0 && i % 10==0 || v==0 && (i % 10>=5 && i % 10<=9) || v==0 && (i % 100>=11 && i % 100<=14)'
		},
		"uk" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14)',
			"many" : 'v==0 && i % 10==0 || v==0 && (i % 10>=5 && i % 10<=9) || v==0 && (i % 100>=11 && i % 100<=14)'
		}
	}
};
